import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { KeyDisplayNamePipe } from '../../../../shared/components/stepper/pipes/key-display-name.pipe';
import { TableColumnsType } from '../../../../shared/enums/common';
import { TooltipModule } from 'primeng/tooltip';

export interface ColumnData {
  name: string;
  displayName?: string;
  type?: string;
  hasTag?: boolean;
  tag?: string;
  buttonLabel?: string;
}

@Component({
  selector: 'app-basic-table',
  standalone: true,
  imports: [CommonModule, TooltipModule, KeyDisplayNamePipe],
  templateUrl: './basic-table.component.html',
  styleUrl: './basic-table.component.scss',
})
export class BasicTableComponent {
  readonly tableData = input<{ columns: ColumnData[]; data: any[] }>();
  readonly showIndex = input(false);
  readonly tableName = input<string>('');
  tableColumnsType = TableColumnsType;
}
